import { NOTIFICATION_STATUS_CODE } from '../enums/notification-status-code.enum';

export type NotificationStatus = Readonly<{
    statusCode: NOTIFICATION_STATUS_CODE;
    startTime: string;
    endTime: string;
}>;

export const initialNotificationStatusState: NotificationStatus = {
    statusCode: NOTIFICATION_STATUS_CODE.DISP,
    startTime: '',
    endTime: '',
};
